<template>
  <a-avatar :size="props.size" v-if="props.src?.length > 0" :src="setAvatar(props.src)"> </a-avatar>
  <img
    src="@/assets/images/login/userAvatar.png"
    :style="{
      width: `${props.size}px`,
      height: `${props.size}px`
    }"
    v-else
  />
</template>

<script setup>
import { Avatar as AAvatar } from 'ant-design-vue'
import { setAvatar } from '@/utils'

const props = defineProps({
  src: {
    type: String,
    default: ''
  },
  size: {
    type: String || Number,
    default: '32'
  }
})
</script>

<style lang="less"></style>
